// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"437":"853c9f56","453":"a8b6299f"}[chunkId] + ".chunk.js";
};